import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AiColSaveAsTemplateModal from './ai-col-save-as-template-modal';
import { AiColSaveAsTemplateModalProps } from './types';
import {
  createAiColumnTemplateRequest,
  getTemplateByIdRequest,
  updateAiColumnTemplateRequest,
} from '../../../../extra-actions';
import {
  resetCreateAiColumnTemplateRequest,
  resetUpdateAiColumnTemplateRequest,
} from '../../../../prospect-slice';
import { RootState } from '../../../../../../store/root-reducer';

const AiColSaveAsTemplateModalContainer = memo(
  (props: AiColSaveAsTemplateModalProps) => {
    const dispatch = useDispatch();

    const createAiColumnTemplateRequests = useCallback(
      (payload: any) => {
        dispatch(createAiColumnTemplateRequest(payload));
      },
      [dispatch],
    );

    const updateAiColumnTemplateRequests = useCallback(
      (payload: { templateId: number; payload: any }) => {
        dispatch(updateAiColumnTemplateRequest(payload));
      },
      [dispatch],
    );

    const getTemplateByIdRequests = useCallback(
      (payload: { templateId: number }) => {
        dispatch(getTemplateByIdRequest(payload));
      },
      [dispatch],
    );

    const resetCreateAiColumnTemplateRequests = useCallback(() => {
      dispatch(resetCreateAiColumnTemplateRequest());
    }, [dispatch]);

    const resetUpdateAiColumnTemplateRequests = useCallback(() => {
      dispatch(resetUpdateAiColumnTemplateRequest());
    }, [dispatch]);

    const createAiColumnTemplateRequestState = useSelector(
      (state: RootState) => state.prospect.createAiColumnTemplateRequest,
    );

    const updateAiColumnTemplateRequestState = useSelector(
      (state: RootState) => state.prospect.updateAiColumnTemplateRequest,
    );

    const selectedAiTemplateId = useSelector(
      (state: RootState) => state.prospect?.selectedAiTemplateId,
    );

    return (
      <AiColSaveAsTemplateModal
        {...props}
        createAiColumnTemplateRequests={createAiColumnTemplateRequests}
        updateAiColumnTemplateRequests={updateAiColumnTemplateRequests}
        getTemplateByIdRequests={getTemplateByIdRequests}
        resetCreateAiColumnTemplateRequests={resetCreateAiColumnTemplateRequests}
        resetUpdateAiColumnTemplateRequests={resetUpdateAiColumnTemplateRequests}
        createAiColumnTemplateRequestState={createAiColumnTemplateRequestState}
        updateAiColumnTemplateRequestState={updateAiColumnTemplateRequestState}
        selectedAiTemplateId={selectedAiTemplateId}
      />
    );
  },
);

export default AiColSaveAsTemplateModalContainer;
